    // lozad lazy-loading as directive
    var lozadDirective = {
        bind(el, binding) {
            el.setAttribute('data-background-image', binding.value);

            let vueObserver = lozad(el);
            vueObserver.observe();
        }
    }
    Vue.directive('lozad', lozadDirective)
    
    // Wait for DOM to be ready
    document.addEventListener('DOMContentLoaded', function() {
        // Get data from the HTML element
        var collectionElement = document.getElementById('collection-app');
        if (!collectionElement) {
            console.error('Collection app element not found');
            return;
        }
        
        var position = Number(collectionElement.getAttribute('data-tile-position') - 2);
        var tile_size = Number(collectionElement.getAttribute('data-tile-size'));

        var collectionApp = new Vue({
        name: "CollectionApp",
        delimiters: [
            '${', '}'
        ],
        el: '#collection-app',

        data: {
            collection: null,
            selected_item: {
                product_id: null,
                product_title: null,
                product_type: null,
                variant_id: null,
                quantity: 1,
                variant_available: null,
                variant_display_amazon_link: null,
                variant_amazon_link: null,
                max_available: null,
                product_image: null,
                product_price: null,
                product_compare_price: null,
                product_url: null,
                state: {
                    all_available: true,
                    is_bundle: false,
                    bundle_items: {
                        items: []
                    }
                }
            },
            all_products: [],
            tagFilters: [],
            categoryFilters: [],
            sizeFilters: [],
            filters: [],
            tile_position: position,
            tiles: tile_size
        },

        methods: {
          backInStockForm(event) {
                $(event.target).closest(".collection-vue__container__products__product").find("#backInStockPopup").show();
            },
            closebackInStockForm (event) {
                $(event.target).closest(".collection-vue__container__products__product").find("#backInStockPopup").hide();
            },
            async notifyBackInStock(event) {
            var prodOption = $(event.target).closest(".collection-vue__container__products__product").find(".product-selector");
            var varOption = $(event.target).closest(".collection-vue__container__products__product").find(":selected");
            var phone = $(event.target).closest(".collection-vue__container__products__product").find("#phone");
            var email = $(event.target).closest(".collection-vue__container__products__product").find("#email");
            var notValid = $(event.target).closest(".collection-vue__container__products__product").find(".notValid");
            var notValidPhone = $(event.target).closest(".collection-vue__container__products__product").find(".notValidPhone");
            var notValidEmail = $(event.target).closest(".collection-vue__container__products__product").find(".notValidEmail")

            var phoneRegex = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
            var emailRegex = /^\S+@\S+\.\S+$/;
                if (phone.val() == '' && email.val() == '') {
                    notValid.css("display", "flex");
                    phone.css("border-color", "rgb(199, 36, 78)");
                    email.css("border-color", "rgb(199, 36, 78)");
                } else if (phone.val() != '' && !phone.val().match(phoneRegex)) {
                    email.css("border-color", "rgb(179, 198, 247)");
                    phone.css("border-color", "rgb(199, 36, 78)");
                    notValidPhone.css("display", "flex");
                    notValid.css("display", "none");
                } else if (email.val() != '' && !email.val().match(emailRegex)) {
                    phone.css("border-color", "rgb(179, 198, 247)");
                    email.css("border-color", "rgb(199, 36, 78)");
                    notValidEmail.css("display", "flex");
                    notValid.css("display", "none");
                } else if (phone.val().match(phoneRegex) || email.val().match(emailRegex) ) {
                    phone.css("border-color", "rgb(179, 198, 247)");
                    email.css("border-color", "rgb(179, 198, 247)");
                    notValid.css("display", "none");

                    // Get button and store original text
                    var submitBtn = $(event.target);
                    var originalText = submitBtn.text();
                    submitBtn.text('Loading...').prop('disabled', true);

                    // Make API calls
                    try {
                        const apiCalls = [];
                        const results = {};
                        
                        if (phone.val()) {
                            apiCalls.push(
                                fetch('https://back-in-stock-app.fly.dev/api/attentive/subscribe', {
                                    method: 'POST',
                                    headers: { 'Content-Type': 'application/json' },
                                    body: JSON.stringify({ phone: phone.val(), variantId: varOption.attr("data-id"), variantName: varOption.attr("data-product-title"), variantSize: varOption.attr("data-title") })
                                }).then(async (response) => {
                                    if (!response.ok) throw new Error('Attentive API failed');
                                    results.attentive = await response.json();
                                })
                            );
                        }
                        
                        if (email.val()) {
                            apiCalls.push(
                                fetch('https://back-in-stock-app.fly.dev/api/klaviyo/back_in_stock', {
                                    method: 'POST',
                                    headers: { 'Content-Type': 'application/json' },
                                    body: JSON.stringify({ email: email.val(), variantId: varOption.attr("data-id") })
                                }).then(async (response) => {
                                    if (!response.ok) throw new Error('Klaviyo API failed');
                                    results.klaviyo = await response.json();
                                })
                            );
                        }
                        
                        await Promise.all(apiCalls);
                        
                        // Success - show thanks popup
                        submitBtn.text(originalText).prop('disabled', false);
                        $(event.target).closest(".collection-vue__container__products__product").find(".popup-content").hide();
                        $(event.target).closest(".collection-vue__container__products__product").find(".popup-content.thanks").show();
                        
                        // if (results.attentive) console.log('Attentive API Response:', results.attentive);
                        // if (results.klaviyo) console.log('Klaviyo API Response:', results.klaviyo);
                    } catch (error) {
                        console.error('BIS API Error:', error);
                        // Failure - show try again popup
                        submitBtn.text(originalText).prop('disabled', false);
                        $(event.target).closest(".collection-vue__container__products__product").find(".popup-content").hide();
                        $(event.target).closest(".collection-vue__container__products__product").find(".popup-content.try-again").show();
                    }
                }
            },
            gotIt(event) {
                $(event.target).closest(".collection-vue__container__products__product").find("#backInStockPopup").hide();
                $(event.target).closest(".collection-vue__container__products__product").find(".popup-content").show();
                $(event.target).closest(".collection-vue__container__products__product").find(".popup-content.thanks").hide();
            },
            getCollection(filters) {
                var collectionHandle = this.$el.getAttribute('data-collection-handle');
                fetch('/collections/' + collectionHandle + '?view=json')
                    .then(response => response.json())
                    .then(data => this.collection = data)
                    .then(data => this.all_products = data.products)
                    .then(function(data) {
                        var queryString = window.location.search;
                        var urlParams = new URLSearchParams(queryString);
                        var query = urlParams.get('filter');

                        if (query == 'fresh-clean' || query == 'warm-spicy' || query == 'floral-fruity' || query == 'herbal-woody') {
                            window.collectionApp.filters.push(query);

                            var filterButton = $('.scents button[data-filter=' + query + ']');
                            filterButton.attr('aria-pressed', 'true');
                            filterButton.addClass('is-active');
                        }
                    });
            },
            filteredProducts(filters, filters2, filters3, type) {
                const filterByTags = (product, tags) =>
                    product.tags.some(tag => tags.includes(tag));

                const filterByCategory = (product, categories) =>
                    categories.includes(product.type);

                const filterBySize = (product, sizes) =>
                    product.variants.some(variant => sizes.includes(variant.title));

                let filtered = this.all_products;

                switch (type) {
                    case "tag":
                        return filtered.filter(product => filterByTags(product, filters));

                    case "category":
                        return filtered.filter(product => filterByCategory(product, filters));

                    case "size":
                        return filtered.filter(product => filterBySize(product, filters));

                    case "filteredCategory":
                        return filtered
                            .filter(product => filterByCategory(product, filters))
                            .filter(product => filterByTags(product, filters2));

                    case "filteredTag":
                        return filtered
                            .filter(product => filterByTags(product, filters))
                            .filter(product => filterByCategory(product, filters2));

                    case "filteredTagCategory":
                        return filtered
                            .filter(product => filterByTags(product, filters))
                            .filter(product => filterByCategory(product, filters2))
                            .filter(product => filterBySize(product, filters3));

                    case "filteredSizeForCategory":
                        return filtered
                            .filter(product => filterBySize(product, filters))
                            .filter(product => filterByCategory(product, filters2));

                    case "filteredCategoryForSize":
                        return filtered
                            .filter(product => filterByCategory(product, filters))
                            .filter(product => filterBySize(product, filters2));

                    case "filteredSizeForTag":
                        return filtered
                            .filter(product => filterBySize(product, filters))
                            .filter(product => filterByTags(product, filters2));

                    case "filteredTagForSize":
                        return filtered
                            .filter(product => filterByTags(product, filters))
                            .filter(product => filterBySize(product, filters2));

                    default:
                        return [];
                }
            },
            openFilterList(event) {
                var button = $(event.target)
                button.toggleClass("activeFilter");
                var content = button.next();
                if (content.css('display') == "flex") {
                    content.hide();
                } else {
                    content.css('display', "flex");
                }
            },
            clearFilters() {
                var products = $(".collection-vue__container__products"),
                    filters = $(".collection-vue__container__filter"),
                    buttons = $(".filter");

                if ($('.js-filter-toggle__toggle').attr('aria-expanded') == "false") {
                    $('.js-filter-toggle__toggle').attr('aria-expanded', 'true');
                    $('.js-filter-toggle__toggle').html('hide filters');
                } else {
                    $('.js-filter-toggle__toggle').attr('aria-expanded', 'false');
                    $('.js-filter-toggle__toggle').html('filter');
                } products.toggleClass('filters-active');
                filters.toggleClass('expanded');

                buttons.attr('aria-pressed', 'false');
                buttons.removeClass('is-active');
                this.tagFilters = [];
                this.categoryFilters = [];
                this.sizeFilters = [];
            },
            showFilters() {
                $(window).scrollTop(0);
                var products = $(".collection-vue__container__products"),
                    filters = $(".collection-vue__container__filter");

                if ($('.js-filter-toggle__toggle').attr('aria-expanded') == "false") {
                    $('.js-filter-toggle__toggle').attr('aria-expanded', 'true');
                    $('.js-filter-toggle__toggle').html('hide filters');
                } else {
                    $('.js-filter-toggle__toggle').attr('aria-expanded', 'false');
                    $('.js-filter-toggle__toggle').html('filter');
                } products.toggleClass('filters-active');
                filters.toggleClass('expanded');
                setTimeout(function() {
                    var amount = $('.collection-vue__container__products__product').length;
                    var amountString = amount.toString();
                    $('.collection-vue__container__filter .results strong span').text(amountString);
                }, 10);
            },
            showSlider(filterType) {
                var sliderIds = ['scent', 'odor', 'occasion', 'category'];
                var targetId = filterType;

                if (filterType == 'category' && !document.getElementById('category')) {
                    targetId = 'occasion';
                }

                var targetSlider = document.getElementById(targetId);
                if (!targetSlider) return;

                var isActive = targetSlider.classList.contains('active');
                var hasOpenSlider = sliderIds.some(function(sliderId) {
                    var slider = document.getElementById(sliderId);
                    return slider && sliderId != targetId && slider.classList.contains('active');
                });

                $('[data-slider-filter]').removeClass('active').attr('aria-pressed', 'false');

                if (isActive) {
                    targetSlider.classList.add('is-closing');
                    targetSlider.classList.remove('active');

                    window.setTimeout(function() {
                        targetSlider.classList.remove('is-closing');
                    }, 350);

                    return;
                }

                sliderIds.forEach(function(sliderId) {
                    var slider = document.getElementById(sliderId);
                    if (slider) slider.classList.remove('active', 'is-closing', 'no-slide-down');
                });

                if (hasOpenSlider) targetSlider.classList.add('no-slide-down');
                targetSlider.classList.add('active');
                $('[data-slider-filter="' + filterType + '"]').addClass('active').attr('aria-pressed', 'true');
            },
            filterCategory(category, event, type) {
                if (type == "ProductType") {
                    setTimeout(function() {
                        var amount = $('.collection-vue__container__products__product').length;
                        var amountString = amount.toString();
                        $('.collection-vue__container__filter .results strong span').text(amountString);
                    }, 10);
                    var button = $(event.target),
                        pressed = button.attr('aria-pressed');

                    if (pressed == "true") {
                        this.categoryFilters.splice(this.categoryFilters.indexOf(category), 1);
                        button.attr('aria-pressed', 'false');
                        button.removeClass('is-active');
                    } else {
                        this.categoryFilters.push(category);
                        button.attr('aria-pressed', 'true');
                        button.addClass('is-active');
                    }
                } else if (type == "ProductTag") {
                    setTimeout(function() {
                        var amount = $('.collection-vue__container__products__product').length;
                        var amountString = amount.toString();
                        $('.collection-vue__container__filter .results strong span').text(amountString);
                    }, 10);
                    var button = $(event.target),
                        pressed = button.attr('aria-pressed');

                    if (pressed == "true") {
                        this.tagFilters.splice(this.tagFilters.indexOf(category), 1);
                        button.attr('aria-pressed', 'false');
                        button.removeClass('is-active');
                    } else {
                        this.tagFilters.push(category);
                        button.attr('aria-pressed', 'true');
                        button.addClass('is-active');
                    }
                }
            },
            filterTag(tag, event) {
                setTimeout(function() {
                    var amount = $('.collection-vue__container__products__product').length;
                    var amountString = amount.toString();
                    $('.collection-vue__container__filter .results strong span').text(amountString);
                }, 10);
                var button = $(event.target),
                    pressed = button.attr('aria-pressed');

                if (pressed == "true") {
                    this.tagFilters.splice(this.tagFilters.indexOf(tag), 1);
                    button.attr('aria-pressed', 'false');
                    button.removeClass('is-active');
                } else {
                    this.tagFilters.push(tag);
                    button.attr('aria-pressed', 'true');
                    button.addClass('is-active');
                }
            },
            filterSize(size, event) {
                setTimeout(function() {
                    var amount = $('.collection-vue__container__products__product').length;
                    var amountString = amount.toString();
                    $('.collection-vue__container__filter .results strong span').text(amountString);
                }, 10);
                var button = $(event.target),
                    pressed = button.attr('aria-pressed');

                if (pressed == "true") {
                    this.sizeFilters.splice(this.sizeFilters.indexOf(size), 1);
                    button.attr('aria-pressed', 'false');
                    button.removeClass('is-active');
                } else {
                    this.sizeFilters.push(size);
                    button.attr('aria-pressed', 'true');
                    button.addClass('is-active');
                }
            },
            selectItem(item, event, type) {

            if( $(event.target).closest(".collection-vue__container__products__product").find(".compared-to-price").is(":visible") ) {
                $(event.target).closest(".collection-vue__container__products__product").find(".price", "compared-to-price").addClass("main-price")
            }
                
                $(".collection-vue__container__products__product").removeClass("is-active otp sub ");
                
                if (type == "otp") {
                    $(event.target).closest(".collection-vue__container__products__product").addClass("is-active otp"); 
                } else if (type == "sub") {
                    $(event.target).closest(".collection-vue__container__products__product").addClass("is-active sub"); 
                } else if (type == "bundle") {
                    $(event.target).closest(".collection-vue__container__products__product").addClass("is-active bundle"); 
                }

                var option = $(event.target).closest(".collection-vue__container__products__product").find(".size-selector[aria-pressed='true']");

                if (option.length == 0) { // set aria-pressed on first button element

                // var page_url = window.location.href
                // console.log('page_url', page_url)

                var pack = 1;
                    var defaultVariant = item.variants.find(function (v) {
                        return v.id == item.first_variant;
                    }) || item.variants[0];

                    if (window.location.href == 'https://pourri.com/collections/toilet-sprays' && item.title.includes("Pocket Sprayer")) {
                        $(event.target)
                        .closest(".collection-vue__container__products__product")
                        .find(".size-selector[data-available='true']")
                        .eq(2)
                        .attr("aria-pressed", true);
                        pack = 4;
                    } else {
                        var selectedBtn = $(event.target)
                            .closest(".collection-vue__container__products__product")
                            .find(".size-selector[data-id='" + item.first_variant + "']");

                        if (selectedBtn.length) {
                            selectedBtn.attr("aria-pressed", true);
                        } else {
                            $(event.target)
                                .closest(".collection-vue__container__products__product")
                                .find(".size-selector[data-available='true']")
                                .first()
                                .attr("aria-pressed", true);
                        }
                    }

                    window.collectionApp.selected_item = {
                        product_plan: type,
                        product_id: item.id,
                        product_title: item.title,
                        product_type: item.type,
                        product_url: item.url,
                        product_price: defaultVariant.price,
                        product_compare_price: defaultVariant.compare_to_price,
                        product_image: item.first_variant_image,
                        variant_id: defaultVariant.id,
                        variant_available: defaultVariant.available,
                        max_available: defaultVariant.quantity,
                        state: {
                            is_bundle: item.is_bundle,
                            all_available: true,
                            bundle_items: item.bundle_items
                        },
                        quantity: pack
                    };

                    // console.log('Selected item data:', {
                    //     display_amazon_link: item.display_amazon_link_first_variant,
                    //     amazon_link: item.amazon_link_first_variant,
                    //     product_id: item.id,
                    //     product_title: item.title
                    // });

                    // is bundle?
                    if (window.collectionApp.selected_item.state.is_bundle == true) {
                        window.collectionApp.allBundleItemsAvailabe(window.collectionApp.selected_item.state.bundle_items.items);
                    }

                } else {
                    var pack = $(event.target).closest(".collection-vue__container__products__product").find(".size-selector[aria-pressed='true']").attr("value");
                    var activeVariant = item.variants.find(function (v) {
                        return v.id == option.attr("data-id");
                    }) || item.variants[0];
                    this.selected_item = {
                        product_plan: type,
                        product_id: item.id,
                        product_title: item.title,
                        product_type: item.type,
                        product_url: item.url,
                        product_price: activeVariant.price,
                        product_compare_price: activeVariant.compare_to_price,
                        product_image: item.first_variant_image,
                        variant_id: option.attr("data-id"),
                        variant_available: option.attr("data-available"),
                        variant_display_amazon_link: option.attr("data-display-amazon-link"),
                        variant_amazon_link: option.attr("data-amazon-link"),
                        max_available: option.attr("data-qty"),
                        state: {
                            is_bundle: item.is_bundle,
                            all_available: true,
                            bundle_items: item.bundle_items
                        },
                        quantity: pack
                    };

                    // console.log('Selected item data (variant):', {
                    //     display_amazon_link: item.variants[0].display_amazon_link,
                    //     amazon_link: item.variants[0].amazon_link,
                    //     product_id: item.id,
                    //     product_title: item.title,
                    //     variant_id: option.attr("data-id")
                    // });

                    // is bundle?
                    if (window.collectionApp.selected_item.state.is_bundle == true) {
                        window.collectionApp.allBundleItemsAvailabe(window.collectionApp.selected_item.state.bundle_items.items);
                    }
                }

            },
            setVariant(variant, event) {
                var button = $(event.target).closest(".collection-vue__container__products__product").find('.addToCart');

                // Low Stock Notice
                if (variant.quantity > 0 && variant.quantity < 100) {
                    $(event.target).closest(".collection-vue__container__products__product").find('.left-stock').html(`<p>Only ${variant.quantity} left in stock</p>` );
                } else {
                    $(event.target).closest(".collection-vue__container__products__product").find('.left-stock p').remove();
                }

                if (variant.available == false) {
                    button.prop("disabled", true);
                    button.addClass('out-of-stock');
                    button.html('out of stock');
                } else {
                    button.prop("disabled", false);
                    button.removeClass('out-of-stock');
                    button.html('add to bag');
                }

                var pressed = $(event.target).closest(".size-options").find(".size-selector[aria-pressed='true']");
                pressed.attr("aria-pressed", "false");

                var price = $(event.target).closest(".collection-vue__container__products__product").find(".prices-ribbon .price");
                price.html(variant.price);
                var sub_price = $(event.target).closest(".collection-vue__container__products__product").find(".form.sub .price");
                sub_price.html(variant.sub_price);

                var compare_to_price = $(event.target).closest(".collection-vue__container__products__product").find(".compared-to-price");
                if (price != compare_to_price) {
                    compare_to_price.show();
                }
                compare_to_price.html(variant.compare_to_price);

                var saleRibbon = $(event.target).closest(".collection-vue__container__products__product").find(".ribbon-wrapper [data-ribbon='sale']");
                if (variant.compare_to_price == '') {
                    saleRibbon.hide();
                } else {
                    saleRibbon.show();
                    saleRibbon.text(Math.round(((variant.compare_to_price.replace('$','') - variant.price.replace('$','')) / variant.compare_to_price.replace('$','')) * 100) + '% Off!')
                }

                $(event.target).attr("aria-pressed", "true");
                $(event.target).closest(".collection-vue__container__products__product").find(".front-img").css('backgroundImage', 'url(' + variant.image + ')');
                $(event.target).closest(".collection-vue__container__products__product").find(".hover-img").css('backgroundImage', 'url(' + (variant.hover_image || variant.image) + ')');

                this.selected_item.variant_id = variant.id;
                this.selected_item.variant_available = variant.available;
                this.selected_item.variant_display_amazon_link = variant.display_amazon_link;
                this.selected_item.variant_amazon_link = variant.amazon_link;
                this.selected_item.max_available = variant.quantity;
                this.selected_item.product_image = variant.image;
                this.selected_item.product_price = variant.price;
                this.selected_item.product_compare_price = variant.compare_to_price;
            },
            addItemToBag(event, option, productId, productTags) {
                
                var quickAddBtn = $(event.target).closest(".product-cta").find('.addToCart');
                var quickAddSubBtn = $(event.target).closest(".product-cta").find('.addSubscriptionToCart');
                var productTitle = this.selected_item.product_title;

                var dataPid = `[data-pid="` + productId + `"] #rtxSPGId`;

                let cartItems = {
                    quantity: this.selected_item.quantity,
                    id: this.selected_item.variant_id,
                    properties: {
                        '_is_bundle': false,
                        '_Type': 'OneTimePurchase',
                        '_attribution': 'One Time Purchase'
                    }
                };

                if (option === "subscription") {
                    cartItems.selling_plan = $(dataPid).val();
                    cartItems.properties['_Type'] = 'Subscription';
                    cartItems.properties['_attribution'] = 'Subscription';
                } else if (
                    this.selected_item.quantity >= 4 &&
                    !productTags.includes("gift-card") &&
                    (this.selected_item.product_compare_price === '' || 
                    this.selected_item.product_price === this.selected_item.product_compare_price)
                ) {
                    if (this.selected_item.variant_id === 41736050114657) {
                        cartItems.properties['_attribution'] = 'PottyPack';
                    } else {
                        cartItems.properties['_attribution'] = 'Pack';
                    }
                } else if (
                    this.selected_item.product_compare_price !== '' &&
                    this.selected_item.product_price !== this.selected_item.product_compare_price
                ) {
                    cartItems.properties['_attribution'] = 'One Time Purchase Discounted';
                }

                // Updated add to cart with correct success
                $.ajax({
                    url: '/cart/add.json',
                    type: 'post',
                    dataType: 'json',
                    data: cartItems,
                    success: function(response) {
                        console.log('');
                        console.log('%c' + response.title + "%c was added to cart.", 'color: green', 'color: black',);

                        if (showVueCart == true) {
                            window.miniCart.refreshCart();
                        }
                        
                        _learnq.push(['track', 'Added to Cart',
                            {
                                "name": window.collectionApp.selected_item.product_title,
                                "productID": window.collectionApp.selected_item.product_id,
                                "imageURL": "https:" + window.collectionApp.selected_item.product_image,
                                "URL": "https://pourri.com" + window.collectionApp.selected_item.product_url,
                                "brand": "~Pourri",
                                "price": window.collectionApp.selected_item.product_price
                            }
                        ]);
                    },
                    error: function(response) {
                        var errors = JSON.parse(response.responseText);
                        console.log(errors.errors);
                    }
                });

                setTimeout(function() {
                    this.selected_item = {
                        product_id: null,
                        product_title: null,
                        variant_id: null,
                        quantity: 1
                    };
                }, 1000);


                if (option == "subscription") {
                    quickAddSubBtn.html('Added!');
                    quickAddSubBtn.addClass('added');

                    setTimeout(function() {
                        quickAddSubBtn.html('Subscribe');
                        quickAddSubBtn.removeClass('added');
                    }, 2500);
                } else {
                    quickAddBtn.html('Added!');
                    quickAddBtn.addClass('added');

                    setTimeout(function() {
                        quickAddBtn.html('quick add');
                        quickAddBtn.removeClass('added');
                    }, 2500);
                }
            },
            addBundleToBag() {
                var items = [],
                    bundleItems = window.collectionApp.selected_item.state.bundle_items.items;

                var quickAddBtn = $(event.target).closest(".product-cta").find('.quick-add');

                for (i = 0; i < bundleItems.length; i ++) {
                    items.push({
                        quantity: bundleItems[i].quantity * window.collectionApp.selected_item.quantity,
                        id: bundleItems[i].variant_id,
                        properties: {
                            '_is_bundle': true,
                            'Bundle': window.collectionApp.selected_item.product_title,
							'_Type': 'OneTimePurchase',
                            '_attribution': 'Bundle'
                        }
                    });
                }

                jQuery.post('/cart/add.js', {
                    items: items,
                    success: function() {
                        // console.log("Items to add: " + JSON.stringify(items));
                        console.log('Added bundle to cart with =>', items);

                        setTimeout(function() {
                            if (showVueCart == true) {
                                window.miniCart.refreshCart();
                            }
                        }, 2000);
                    }
                });

                this.selected_item = {
                    product_id: null,
                    product_title: null,
                    variant_id: null,
                    quantity: 1
                };

                $(".collection-vue__container__products__product").removeClass("is-active");

                quickAddBtn.html('Added!');
                quickAddBtn.addClass('added');

                setTimeout(function() {
                    quickAddBtn.html('quick add');
                    quickAddBtn.removeClass('added');
                }, 2500);
            },
            verifyBundleVariants(items, variant) {
                for (var i = 0; i < items.length; i++) {
                    if (items[i].id == variant && items[i].available == false) {
                        window
                            .collectionApp
                            .selected_item
                            .state
                            .all_available = false;
                    }
                }
            },
            allBundleItemsAvailabe(items) {
                for (var i = 0; i < items.length; i++) {
                    let id = items[i].variant_id;

                    fetch("/products/" + items[i].handle + "?view=json").then((response) => response.json()).then(function(data) {

                    // console.log(data.variants);
                        window.collectionApp.verifyBundleVariants(data.variants, id)
                    }).catch(error => {
                        console.log('Bundle item not availabe.');
                        window
                            .collectionApp
                            .selected_item
                            .state
                            .all_available = false;
                    });
                }
            }
        },

        watch: {
            categoryFilters() {
                const { categoryFilters, tagFilters, sizeFilters } = this;

                const filtersPresent = {
                    category: categoryFilters.length > 0,
                    tag: tagFilters.length > 0,
                    size: sizeFilters.length > 0
                };

                if (filtersPresent.category && filtersPresent.tag && filtersPresent.size) {
                    this.collection.products = this.filteredProducts(tagFilters, categoryFilters, sizeFilters, "filteredTagCategory");
                } else if (!filtersPresent.category && filtersPresent.tag && filtersPresent.size) {
                    this.collection.products = this.filteredProducts(tagFilters, sizeFilters, null, "filteredTagForSize");
                } else if (filtersPresent.category && filtersPresent.tag && !filtersPresent.size) {
                    this.collection.products = this.filteredProducts(tagFilters, categoryFilters, null, "filteredTag");
                } else if (filtersPresent.category && !filtersPresent.tag && filtersPresent.size) {
                    this.collection.products = this.filteredProducts(sizeFilters, categoryFilters, null, "filteredSizeForCategory");
                } else if (!filtersPresent.category && !filtersPresent.tag && filtersPresent.size) {
                    this.collection.products = this.filteredProducts(sizeFilters, null, null, "size");
                } else if (filtersPresent.category && !filtersPresent.tag && !filtersPresent.size) {
                    this.collection.products = this.filteredProducts(categoryFilters, null, null, "category");
                } else if (!filtersPresent.category && filtersPresent.tag && !filtersPresent.size) {
                    this.collection.products = this.filteredProducts(tagFilters, null, null, "tag");
                } else {
                    this.collection.products = this.all_products;
                }
            },
            tagFilters() {
                if (this.categoryFilters.length > 0 && this.tagFilters.length > 0 && this.sizeFilters.length > 0) {
                    this.collection.products = this.filteredProducts(this.tagFilters, this.categoryFilters, this.sizeFilters, "filteredTagCategory");
                } else if (this.categoryFilters.length > 0 && this.tagFilters.length == 0 && this.sizeFilters.length > 0) {
                    this.collection.products = this.filteredProducts(this.categoryFilters, this.sizeFilters, null, "filteredCategoryForSize");
                } else if (this.categoryFilters.length > 0 && this.tagFilters.length > 0 && this.sizeFilters.length == 0) {
                    this.collection.products = this.filteredProducts(this.categoryFilters, this.tagFilters, null, "filteredCategory");
                } else if (this.categoryFilters.length == 0 && this.tagFilters.length > 0 && this.sizeFilters.length > 0) {
                    this.collection.products = this.filteredProducts(this.sizeFilters, this.tagFilters, null, "filteredSizeForTag");
                } else if (this.categoryFilters.length == 0 && this.tagFilters.length == 0 && this.sizeFilters.length > 0) {
                    this.collection.products = this.filteredProducts(this.sizeFilters, null, null, "size");
                } else if (this.categoryFilters.length == 0 && this.tagFilters.length > 0 && this.sizeFilters.length == 0) {
                    this.collection.products = this.filteredProducts(this.tagFilters, null, null, "tag");
                } else if (this.categoryFilters.length > 0 && this.tagFilters.length == 0 && this.sizeFilters.length == 0) {
                    this.collection.products = this.filteredProducts(this.categoryFilters, null, null, "category");
                } else if (this.categoryFilters.length == 0 && this.tagFilters.length == 0 && this.sizeFilters.length == 0) {
                    this.collection.products = this.all_products;
                }
            },
            sizeFilters() {
                if (this.categoryFilters.length > 0 && this.tagFilters.length > 0 && this.sizeFilters.length > 0) {
                    this.collection.products = this.filteredProducts(this.tagFilters, this.categoryFilters, this.sizeFilters, "filteredTagCategory");
                } else if (this.categoryFilters.length > 0 && this.tagFilters.length > 0 && this.sizeFilters.length == 0) {
                    this.collection.products = this.filteredProducts(this.tagFilters, this.categoryFilters, null, "filteredTag");
                } else if (this.categoryFilters.length > 0 && this.tagFilters.length == 0 && this.sizeFilters.length > 0) {
                    this.collection.products = this.filteredProducts(this.categoryFilters, this.sizeFilters, null, "filteredCategoryForSize");
                } else if (this.categoryFilters.length == 0 && this.tagFilters.length > 0 && this.sizeFilters.length > 0) {
                    this.collection.products = this.filteredProducts(this.tagFilters, this.sizeFilters, null, "filteredTagForSize");
                } else if (this.categoryFilters.length > 0 && this.tagFilters.length == 0 && this.sizeFilters.length == 0) {
                    this.collection.products = this.filteredProducts(this.categoryFilters, null, null, "category");
                } else if (this.categoryFilters.length == 0 && this.tagFilters.length > 0 && this.sizeFilters.length == 0) {
                    this.collection.products = this.filteredProducts(this.tagFilters, null, null, "tag");
                } else if (this.categoryFilters.length == 0 && this.tagFilters.length == 0 && this.sizeFilters.length > 0) {
                    this.collection.products = this.filteredProducts(this.sizeFilters, null, null, "size");
                } else if (this.categoryFilters.length == 0 && this.tagFilters.length == 0 && this.sizeFilters.length == 0) {
                    this.collection.products = this.all_products;
                }
            }
        },

        computed: {
            maxQTY() {
                return this.selected_item.quantity >= this.selected_item.max_available;
            }
        },

        mounted: function() {
            this.getCollection();
        }

    })

        // Make collectionApp available globally
        window.collectionApp = collectionApp;
    });